import { render, staticRenderFns } from "./FormDisks.vue?vue&type=template&id=3f6af11d&scoped=true&"
import script from "./FormDisks.vue?vue&type=script&lang=js&"
export * from "./FormDisks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6af11d",
  null
  
)

export default component.exports